__turbopack_context__.v({
  "btn": "style-module-scss-module__6u-pJW__btn",
  "btn_hidden": "style-module-scss-module__6u-pJW__btn_hidden",
  "btn_pt": "style-module-scss-module__6u-pJW__btn_pt",
  "content": "style-module-scss-module__6u-pJW__content",
  "content_hidden": "style-module-scss-module__6u-pJW__content_hidden",
  "item": "style-module-scss-module__6u-pJW__item",
  "link": "style-module-scss-module__6u-pJW__link",
  "root": "style-module-scss-module__6u-pJW__root",
});
